import { authenticatedJsonFetch } from '@perpay-web/authentication/authenticatedJsonFetch';
import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { BANKS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { BankAccount } from '@perpay-web/fintech/reducers/entities/banks';
import { reportError } from '@perpay-web/utils/errorHandlers';

export const setPrimaryBankAccount = (bankAccountUuid: string) =>
    authenticatedJsonFetch<BankAccount>(
        `${BANKS_ENDPOINT}${bankAccountUuid}`,
        { primary: true },
        HTTPMethod.patch,
    ).catch((error) => {
        reportError(error as Error);
        return null;
    });
